import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { refCount, publishReplay } from 'rxjs/operators';
import { Profile } from './profile.model';
import { ConsentScopesService } from '../config/consent-scopes.service';

@Injectable()
export class ProfileService {
    private profile$: Observable<Profile>;
    private consentScopes: string[];

    constructor(private http: HttpClient,
        private consentScopesService: ConsentScopesService) {
        this.consentScopes = this.consentScopesService.getConsentScopes();
    }

    get profile(): Observable<Profile> {
        if (!this.profile$) {
            this.profile$ = this.http.get<Profile>('profile').pipe(
                publishReplay(1),
                refCount() );
        }
        return this.profile$;
    }

    async refresh(): Promise<void> {
        this.profile$ = null;
    }
}
